<template>
  <div>
    <PageHero position="ABOUT" :fallback="hero" />
    <section id="about" class="section about-split">
      <div>
        <p class="eyebrow">ABOUT VERVESTEEL / {{ $t('common.about') }}</p>
        <h2 class="pre-line">{{ $t('about.title') }}</h2>
        <p>{{ $t('about.intro') }}</p>
        <div class="about-points"><span v-for="point in points" :key="point">{{ point }}</span></div>
      </div>
      <div class="about-photo"><img :src="assets.team" :alt="$t('about.photo')"><div class="photo-label"><span>FROM PLAN TO PERFORMANCE</span><strong>{{ $t('about.photo') }}</strong></div></div>
    </section>
    <section class="brand-story-section">
      <div class="brand-story">
        <div class="brand-story-heading">
          <p class="eyebrow">{{ story.eyebrow }}</p>
          <h2>{{ story.title }}</h2>
          <p class="brand-story-lead">{{ story.lead }}</p>
        </div>
        <div class="brand-story-copy">
          <p v-for="paragraph in story.origin" :key="paragraph">{{ paragraph }}</p>
          <p>{{ story.focus }}</p>
          <div class="brand-belief">
            <p>{{ story.markIntro }}</p>
            <strong>{{ story.mark }}</strong>
            <span>{{ story.markChinese }}</span>
          </div>
          <p>{{ story.promise }}</p>
          <p class="brand-story-closing">{{ story.closing }}</p>
          <p class="brand-story-signature">Vervesteel<br><span>{{ story.signature }}</span></p>
        </div>
      </div>
    </section>
    <section class="tinted"><div class="section about-split"><img :src="assets.factory" :alt="$t('about.builtTitle')" class="wide-image"><div><p class="eyebrow">DESIGNED &amp; BUILT WITH CARE</p><h2 class="pre-line">{{ $t('about.builtTitle') }}</h2><p>{{ $t('about.built1') }}</p><p>{{ $t('about.built2') }}</p><a class="text-link" :href="documents.companyProfile" target="_blank" rel="noopener noreferrer">{{ $t('about.profile') }} <span>↗</span></a></div></div></section>
    <section class="section"><SectionHeading :eyebrow="$t('about.approach')" :title="$t('about.approachTitle')" /><div class="process"><article v-for="(step,index) in steps" :key="step.title"><span>{{ String(index+1).padStart(2,'0') }}</span><h3>{{ step.title }}</h3><p>{{ step.text }}</p></article></div></section>
    <ContactCta />
  </div>
</template>
<script>
import PageHero from '../components/PageHero.vue'
import SectionHeading from '../components/SectionHeading.vue'
import ContactCta from '../components/ContactCta.vue'
import { assets, documents } from '../data/site'
import stories from '../data/brandStory'
export default {
  name:'AboutView', components:{PageHero,SectionHeading,ContactCta}, data(){return{assets,documents}},
  computed:{hero(){return{eyebrow:'ABOUT US',title:this.$t('about.heroTitle'),subtitle:this.$t('about.heroSubtitle'),image:assets.brand}},story(){return stories[this.$i18n.locale]||stories.en},points(){return[1,2,3,4].map(number=>this.$t(`about.point${number}`))},steps(){return[1,2,3,4].map(number=>({title:this.$t(`process.step${number}Title`),text:this.$t(`process.step${number}Text`)}))}}
}
</script>
